<template>
  <div class="d-flex align-self-center">
    <div class="d-flex justify-start align-self-center breadcrumbs">
      <!-- Botón regresar -->
      <v-btn
        icon
        small
        color="white"
        class="back-button mr-1"
        aria-label="Regresar"
        title="Regresar"
        @click="navigateBack"
      >
        <v-icon color="white">
          mdi-arrow-left
        </v-icon>
      </v-btn>

      <!-- Inicio -->
      <v-icon
        color="#ffffff"
        class="breadcrumb-action"
        title="Ir al inicio"
        @click="navigateToHome"
      >
        mdi-home
      </v-icon>

      <v-icon v-if="parent" color="#ffffff">
        mdi-chevron-right
      </v-icon>

      <v-card-subtitle
        v-if="parent"
        class="text-breadcrumbs"
        @click="navigateToParent"
      >
        {{ parent.name }}
      </v-card-subtitle>

      <v-icon v-if="currentRouteName" color="#ffffff">
        mdi-chevron-right
      </v-icon>

      <v-card-subtitle v-if="currentRouteName">
        {{ currentRouteName }}
      </v-card-subtitle>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",

  props: {
    parent: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    host: "Inicio",
    history: null,
  }),

  computed: {
    currentRouteName() {
      const routeName = this.$route.name || null;

      // Evita error cuando parent no fue enviado.
      if (!this.parent) {
        return routeName;
      }

      return routeName !== this.parent.name ? routeName : null;
    },

    user() {
      return this.$store.getters["authenticate/getDataUser"];
    },
  },

  methods: {
    navigateBack() {
      /*
       * window.history.length suele ser mayor a 1 cuando existe
       * una página anterior en el historial del navegador.
       */
      if (window.history.length > 1) {
        this.$router.go(-1);
        return;
      }

      // Si se abrió la URL directamente, intenta regresar al padre.
      if (this.parent && this.parent.view) {
        this.$router.push(this.parent.view);
        return;
      }

      // Último recurso.
      this.$router.push("/");
    },

    navigateToHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },

    navigateToParent() {
      if (!this.parent || !this.parent.view) {
        return;
      }

      if (this.$route.path !== this.parent.view) {
        this.$router.push(this.parent.view);
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

a,
a:hover,
a:focus {
  text-decoration: none !important;
}

a:focus {
  outline: none;
}

.v-application,
.text-h6,
.text-overline {
  font-family: "Poppins", sans-serif !important;
}

.v-application a,
.breadcrumbs {
  background-color: #000000 !important;
  color: #f2f2f2;
}

.breadcrumbs {
  align-items: center;
}

.back-button {
  background-color: transparent !important;
}

.back-button:hover,
.breadcrumb-action:hover {
  opacity: 0.75;
}

.breadcrumb-action {
  cursor: pointer;
}

.text-breadcrumbs {
  cursor: pointer;
}

.text-breadcrumbs:hover {
  color: #ec4036;
}
</style>